import { Box, HStack, Image, Select, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { colors } from "../../../../styles";

export type ObjectStatus = "ACTIVE" | "PENDING" | "REJECTED";

export const OBJECT_STATUS_OPTIONS: ObjectStatus[] = ["ACTIVE", "PENDING", "REJECTED"];

/* 객체/유저 status 점 색상 */
export const getStatusColor = (status?: string) => {
    if (status === "ACTIVE") return colors.green;
    if (status === "PENDING") return colors.yellow;
    if (status === "REJECTED") return colors.apple;
    return colors.gray;
};

export function StatusDot({ status }: { status?: string }) {
    return (
        <Box
            width="8px"
            height="8px"
            borderRadius="4px"
            backgroundColor={getStatusColor(status)}
            flexShrink={0}
        />
    );
}

export function FieldRow({ label, children }: { label: string; children: ReactNode }) {
    return (
        <HStack justifyContent="space-between" alignItems="center" width="100%" py={2} gap={4}>
            <Text fontSize={14} fontWeight={600} color={colors.g2} minWidth="180px">
                {label}
            </Text>
            <Box flex={1}>{children}</Box>
        </HStack>
    );
}

export function ValiditySelect({
    value,
    onChange,
}: {
    value: boolean;
    onChange: (next: boolean) => void;
}) {
    return (
        <Select
            size="sm"
            value={value ? "true" : "false"}
            onChange={(event) => onChange(event.target.value === "true")}
        >
            <option value="true">true</option>
            <option value="false">false</option>
        </Select>
    );
}

export function StatusSelect({
    value,
    onChange,
    rejectDisabled = false,
}: {
    value: ObjectStatus;
    onChange: (next: ObjectStatus) => void;
    rejectDisabled?: boolean;
}) {
    return (
        <HStack>
            <StatusDot status={value} />
            <Select
                size="sm"
                value={value}
                onChange={(event) => onChange(event.target.value as ObjectStatus)}
            >
                {OBJECT_STATUS_OPTIONS.map((option) => (
                    <option
                        key={option}
                        value={option}
                        disabled={rejectDisabled && option === "REJECTED"}
                    >
                        {option}
                    </option>
                ))}
            </Select>
        </HStack>
    );
}

export function ImageThumb({
    url,
    alt,
    onClick,
}: {
    url?: string | null;
    alt: string;
    onClick: (url: string) => void;
}) {
    if (!url) return <Text fontSize={14}>-</Text>;

    return (
        <Box
            width={12}
            height={12}
            borderRadius={4}
            border={`1px solid ${colors.g5}`}
            backgroundColor={colors.g5}
            overflow="hidden"
            cursor="pointer"
            onClick={() => onClick(url)}
        >
            <Image src={url} alt={alt} width="100%" height="100%" objectFit="cover" />
        </Box>
    );
}
